import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook } from "@fortawesome/free-brands-svg-icons";

import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left */}
        <div className="footer-column">
          <h3>LOCATION</h3>

          <p>
            2797 South Parker Rd
            <br />
            Aurora, CO
          </p>

          <div className="footer-contact">
            <a href="tel:3038739999">(303) 873-9999</a>
          </div>
        </div>

        {/* Center */}
        <div className="footer-column">
          <h3>HOURS</h3>

          <div className="footer-hours">
            <p>
              <strong>Mon – Fri</strong>
              <br />
              Lunch: 11:00 AM – 3:00 PM
              <br />
              Dinner: 4:30 PM – 9:30 PM
            </p>

            <p>
              <strong>Sat – Sun</strong>
              <br />
              11:00 AM – 9:30 PM
            </p>

            <p className="holiday-note">Holidays follow weekend pricing</p>
          </div>
        </div>

        {/* Right */}
        <div className="footer-column">
          <h3>CONNECT</h3>

          <div className="social-links">
            <a
              href="https://www.instagram.com/hirojapanesebuffet_official/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} />
              Instagram
            </a>

            <a
              href="https://www.facebook.com/p/Hiro-Japanese-Sushi-Buffet-and-Grill-100053143727870/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} />
              Facebook
            </a>
          </div>

          <div className="footer-links">
            <Link to="/buffet-pricing">Pricing</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/about-us">About</Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Hiro Japanese Buffet & Arcade
      </div>
    </footer>
  );
};

export default Footer;
